import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=5ac84746&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=ts&"
export * from "./chat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac84746",
  null
  
)

export default component.exports